import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfiniteDoctorsParams, IInfiniteDoctorsResponse } from "./types";
import type { IAssignableDoctorsToStaffParams } from "./path";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllAssignableDoctorsToStaff");

type IResponse = IWithInfinite<IInfiniteDoctorsResponse>;
export type IAssignableDoctorsToStaffVariables = IInfiniteDoctorsParams &
  IAssignableDoctorsToStaffParams;
type IVariables = IAssignableDoctorsToStaffVariables;

const getAllAssignableDoctorsToStaff = async (
  { staffId, ...props }: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath({ staffId }), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteAssignableDoctorsToStaff = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllAssignableDoctorsToStaff({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
